// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimePickerSingle.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import typeof { DOMElement } from 'react';
import DateTimePickerContainer from './Izenda.DateTimePickerContainer';
import Input from 'share/components/controls/Izenda.Input';
import { observable } from 'mobx';
import { PickerDimension } from './Izenda.DateTimeConstants';
import DateTimePickerModel from 'logic/models/Izenda.DateTimePickerModel';
import Moment from 'moment';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.DateTimePickerActions';

@connect(actions)
export default class DateTimePickerSingle extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    hidePicker: PropTypes.func.isRequired,
    containerProps: PropTypes.object.isRequired,
    onBlur: PropTypes.func,
    displayFormat: PropTypes.string,
    storeFormat: PropTypes.string,
    renderInContainer: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    placeholder: PropTypes.string
  };

  // Model
  @observable model: DateTimePickerModel = null;

  /**
   * Constructor
   * @param {Object} props
   */
  constructor(props: Object) {
    super(props);
    this.model = new DateTimePickerModel();
    this.setFormats(props);
    this.setData(props);
  }

  /**
   * Component will receive props
   * @param {Object} nextProps
   */
  componentWillReceiveProps(nextProps: Object) {
    const { displayFormat: prevDisplayFormat, storeFormat: prevStoreFormat } = this.props;
    const { displayFormat, storeFormat } = nextProps;
    (prevDisplayFormat !== displayFormat || prevStoreFormat !== storeFormat) && this.setFormats(nextProps);
    this.setData(nextProps);
  }

  /**
   * Set formats for model
   */
  setFormats(props: Object) {
    const { displayFormat, storeFormat } = props;
    this.model.setFormats(displayFormat, storeFormat);
  }

  /**
   * Set data for model
   */
  setData(props: Object) {
    const { value } = props;
    this.model.setData(value);
  }

  /**
   * Set anchor for float affixed
   */
  setAnchor = (node: DOMElement) => {
    this.anchor = node;
  };

  /**
   * On select a date in picker
   */
  onSelect = (dateTime: Moment) => {
    this.model.setDateTime(dateTime);
    this.save();
    const { calendar, time, hidePicker } = this.props;
    calendar && !time && hidePicker();
  };

  /**
   * Save value
   */
  save = () => {
    const { onChange } = this.props;
    const hadChanged = this.model.hadValueChanged();
    hadChanged && onChange && onChange(this.model.getSavingValue());
  };

  /**
   * Render control
   */
  renderControl() {
    const {
      name,
      disabled,
      placeholder,
      calendar,
      onKeyDownInput,
      setInputDOMNode,
      onChangeInput,
      onBlurInput,
      onFocusInput
    } = this.props;
    const { inputValue } = this.model;

    return (
      calendar && (
        <div ref={this.setAnchor} className='u_fullWidth'>
          <Input
            type='text'
            ref={setInputDOMNode(this.model)}
            value={inputValue}
            onBlur={onBlurInput(this.model, this.save)}
            onKeyDown={onKeyDownInput(this.model, this.save)}
            onChange={onChangeInput(this.model, this.save)}
            placeholder={placeholder}
            name={name}
            className='izenda-DateTimePicker-input'
            disabled={disabled}
            onClick={onFocusInput(this.model)}
            onFocus={onFocusInput(this.model)}
          />
        </div>
      )
    );
  }

  /**
   * Render
   */
  render() {
    const calendarProps = {
      onSelect: this.onSelect,
      value: this.model.dateTime
    };

    return (
      <DateTimePickerContainer
        calendarProps={calendarProps}
        anchor={this.anchor}
        pickerAsPopover={this.props.calendar}
        pickerWidth={PickerDimension.SINGLE_WIDTH}
        {...this.props.containerProps}
      >
        {this.renderControl()}
      </DateTimePickerContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/DateTime/Izenda.DateTimePickerSingle.js